// Libs
import _filter from 'lodash/filter'
import _map from 'lodash/map'
import _fromPairs from 'lodash/fromPairs'
import _size from 'lodash/size'
import _toPairs from 'lodash/toPairs'

// Constants
import {
  SERVER,
  PROTOCOL,
} from 'hfty'

export default function url ({
  id,
  queryParams: maybeQueryParams = {},
  path: maybePath,
  url: maybeUrl = maybePath,
  protocol = PROTOCOL,
  server = SERVER,
  token,
  excludeTrailingSlash = false,
}) {
  const [path, query] = `${maybeUrl || ''}`.split('?')
  const paths = _filter(path.match(/[\w-]+/g))
  const queries = _map(_filter(`${query || ''}`.split('&')), (query) => query.split('='))

  const queryParams = {
    ...maybeQueryParams,
    ..._fromPairs(queries),
  }

  if (token) {
    queryParams.token = token
  }

  let url = `${protocol}://${server}/${paths.join('/')}${excludeTrailingSlash ? '' : '/'}`
  if (id) {
    url += id
  }

  if (_size(queryParams)) {
    const tuples = _toPairs(queryParams)

    const queryString = _map(tuples, ([key, value]) => `${key}=${value}`).join('&')
    return `${url}?${queryString}`
  }

  return url
}
